// extracted by mini-css-extract-plugin
export default {"updatedSinceGraded":"updatedSinceGraded__x5YXR"};